import { Injectable, inject } from '@angular/core';
import { LoaderService } from './loader.service';

import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    private loaderService = inject(LoaderService);

    private nbRequests = 0;

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const pathsToIntercept = [
            '/notification/search/consolidated',
            '/backend/logged/catalogue/',
            '/backend/logged/operatorCatalogue/',
            '/notification/search/export',
            '/consumer/search',
            '/public/organization/single/market',
        ];
        if (pathsToIntercept.some((path) => request.url.includes(path))) {
            this.nbRequests++;
            this.loaderService.show();
            return next.handle(request).pipe(
                finalize(() => {
                    this.nbRequests--;
                    if (this.nbRequests === 0) {
                        this.loaderService.hide();
                    }
                })
            );
        }
        return next.handle(request);
    }
}
